import React, { useCallback, useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CityDropdownForTrip, CommonInput, CommonModal, CommonTextarea, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { getAllVehicleNumber, podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { createVehicleGroup } from '_services/accountsServices/vehicleGroupServices';
import { createVehicleDocType, editVehicleDocType } from '_services/accountsServices/vehicleDocTypeServices';
import { createServiceRemainder, createStore, editStore, getItemsList, markRemainderService } from '_services/workShopServices/workShopServices';
import './AddEditMarkCompleteRemainder.css'
import { constant } from 'constants/constant';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';

const formObj = {
    company_id: StorageService.getCompanyId(),
    reminder_id: "",
    service_id: "",
    item_id: {},
    complete_date: new Date(),
    schedule_next_service: 1,  // 0 =no, 1=yes
    odometer: "",
    reminder_date: "",
    reminder_kms: "",
}

const AddEditMarkCompleteRemainder = (props) => {

    const { isOpen, closeModal, nextModal } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    let isCondition = (isOpen?.item?._id && isOpen?.service_id && isOpen?._id) ? false : true;

    useEffect(() => {
        if (isOpen?.isDetails) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
            }))
        }
    }, [isOpen?.isDetails])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        let isAction = ((isOpen?.item?.odometer_reading === 1) && (isOpen?.item?.time_interval === 1)) ? 1 : 0
        if (name === 'odometer') {
            stateObj['reminder_kms'] = isAction ? (+value + (+isOpen?.item?.odometer_kms)) : value; // isAction ? (value + isOpen?.item?.odometer_kms) : value;
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.markRemainderSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            let obj = {
                company_id: StorageService.getCompanyId(),
                reminder_id: formValue?.reminder_id ? formValue?.reminder_id : '',
                service_id: formValue?.service_id ? formValue?.service_id : '',
                item_id: formValue?.item_id?._id ? formValue?.item_id?._id : '',
                complete_date: formValue.complete_date ? utils.getTodayDate(formValue.complete_date) : '',
                schedule_next_service: formValue.schedule_next_service,
                odometer: formValue?.odometer,
                reminder_date: formValue?.schedule_next_service === 1 ? (formValue.reminder_date ? utils.getTodayDate(formValue.reminder_date) : '') : '',
                reminder_kms: formValue?.schedule_next_service === 1 ? formValue?.reminder_kms : '',
            }
            if (!formValue?.service_id) {
                delete obj.service_id;
            }
            delete obj.odometer;
            const res = await markRemainderService(obj);
            if (res?.responseCode == 200) {
                setFormValue({});
                setLoading(false);
                if (res?.responseMessage) {
                    toast.success(res?.responseMessage);
                }
                closeModal(false);
                props?.callListApi();
            } else {
                setLoading(false);
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.markRemainderSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen?._id) {
            let isAction = ((isOpen?.item?.odometer_reading === 1) && (isOpen?.item?.time_interval === 1)) ? 1 : 0
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                reminder_id: isOpen?._id,
                service_id: isOpen?.service_id,
                item_id: isOpen?.item,
                complete_date: new Date(),
                schedule_next_service: isAction,  // 0 =no, 1=yes
                reminder_date: isAction ? utils.getDateAfterDays(new Date(), isOpen?.item?.time_interval_days) : '',
            }))
        }
    }, [isOpen?._id])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        onSubmit: handleClick,
        // footerPart: isCondition ? true : true,
        // hideFooterSumbmitBtn: isCondition ? true : false,
        // hideCompletelyFoolter: isCondition ? true : false,
    }

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            company_id: StorageService.getCompanyId(),
            complete_date: new Date()
        }))
    }, [])

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.markRemainderSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className="_adding_color">
                    <p>Vehicle Number : {isOpen?.vehicle?.vehicle_no ? isOpen?.vehicle?.vehicle_no : ''}</p>
                </div>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='halfDiv'>
                            <CommonInput
                                type="text"
                                label='Item'
                                placeholder='Item'
                                name='Item'
                                value={isOpen?.item?.name ? isOpen?.item?.name : ''}
                                disabled
                            // focus={!!(typeof formError === "object" && formError?.odometer)}
                            // error={!!(typeof formError === "object") ? formError?.odometer : ""}
                            // maxLength="6"
                            // onInput={utils.maxLengthCheck}
                            // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                            />
                        </div>

                        <div className='singleDiv'>
                            <DatePickerComponent
                                label="Completion Date "
                                name="complete_date"
                                showTimeSelect={false}
                                defaultTimeFix={false}
                                startDate={formValue?.complete_date}
                                onChange={(data) => handleOnChange('complete_date', data)}
                                error={!!(typeof formError === "object") ? formError?.complete_date : ""}
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Odometer Reading'
                                placeholder='Odometer Reading'
                                name='odometer'
                                value={formValue.odometer}
                                disabled={isOpen?.isDetails ? true : false}
                                focus={!!(typeof formError === "object" && formError?.odometer)}
                                error={!!(typeof formError === "object") ? formError?.odometer : ""}
                                maxLength="6"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonTextarea
                                type="textarea"
                                label='Remarks'
                                placeholder='Remarks'
                                name='remarks'
                                value={formValue.remarks}
                                focus={!!(typeof formError === "object" && formError?.remarks)}
                                error={!!(typeof formError === "object") ? formError?.remarks : ""}
                                maxLength="500"
                                onInput={utils.maxLengthCheck}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div className="singleDiv">
                            <div className="_payMode_hed">
                                <h4> Schedule Next Reminder </h4>

                                <div className='checkBx_lv p-0 mt-0' style={{ width: '100%' }}>
                                    {
                                        constant.isMarkType?.map((el, ind) => {
                                            return (
                                                <React.Fragment key={ind}>
                                                    <div className='_dualCheckr_bx mt-2' style={{ maxWidth: '85px', width: '100%' }}>
                                                        <input
                                                            style={{ marginTop: '2px' }}
                                                            className="form-check-input"
                                                            id={+ind + "schedule_next_service" + el?.value}
                                                            type="radio"
                                                            name="schedule_next_service"
                                                            checked={formValue?.schedule_next_service === el?.value}
                                                            value={el?.value}
                                                            onChange={(e) => handleOnChange('schedule_next_service', el?.value)}
                                                        />
                                                        <label style={{ fontSize: '14px' }} htmlFor={+ind + "schedule_next_service" + el.value} className="form-check-label" >
                                                            {el.label}
                                                        </label>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                        {formValue?.schedule_next_service ? <>
                            <div className='singleDiv'>
                                <DatePickerComponent
                                    label="Reminder Date"
                                    name="reminder_date"
                                    showTimeSelect={false}
                                    defaultTimeFix={false}
                                    min={new Date()}
                                    startDate={formValue?.reminder_date}
                                    onChange={(data) => handleOnChange('reminder_date', data)}
                                    error={!!(typeof formError === "object") ? formError?.reminder_date : ""}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label='Due at KMs'
                                    placeholder='Due at KMs'
                                    name='reminder_kms'
                                    disabled={true}
                                    value={formValue.reminder_kms}
                                    focus={!!(typeof formError === "object" && formError?.reminder_kms)}
                                    error={!!(typeof formError === "object") ? formError?.reminder_kms : ""}
                                    maxLength="6"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                />
                            </div>
                        </> : <></>}
                    </div>
                </div>
            </CommonModal>
            {/* <div className='offBack_drop'></div> */}

        </div>
    )
}

export default AddEditMarkCompleteRemainder